/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */
import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'mkad-label-error',
  template: `
    @if (show) {
      <span class="mkad__danger text-sm">
        {{ error }}
      </span>
    }
  `,
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [],
})
export class MkadLabelErrorComponent {
  @Input({required: true}) error: string = '';
  @Input({required: true}) show: boolean = false;
}
